import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

import { DomUtil } from '@root/shared/core'
import { LogoGlass } from '@root/shared/ui-kit/icons'

import BG from './assets/auth-modal-bg.svg'

type AuthModalHeaderProps = {}

export const AuthModalHeader: React.FC<AuthModalHeaderProps> = () => {
  const { t } = useTranslation()
  return (
    <Root>
      <Content>
        <LogoGlass size={40} />
        <Group>
          <Title>{t('app.name')}</Title>
          <Pitch>{t('app.pitch')}</Pitch>
        </Group>
      </Content>
    </Root>
  )
}

const Root = styled.div`
  height: 100px;
  background-color: #051719;
  background-image: ${DomUtil.cssUrl(BG)};
  background-position: center;
  background-size: auto 100%;
  position: relative;

  display: grid;
  justify-content: center;
`

const Content = styled.div`
  display: grid;
  align-items: center;
  grid-template-columns: auto minmax(0, 1fr);
  gap: 9px;
  position: absolute;
  // size of image
  width: 465px;

  left: 50%;
  transform: translateX(-50%) translateY(50%);
  padding-left: 136px;
  padding-top: 7px;
`

const Group = styled.div`
  display: grid;
  grid-auto-flow: row;
  gap: 3px;
`

const Title = styled.div`
  font-size: 18px;
  font-weight: 600;
  color: #fff;
`

const Pitch = styled.div`
  color: var(--textA-8);
  font-size: 9px;
  font-weight: 700;
  line-height: 1;
  letter-spacing: 0.54px;
  text-transform: uppercase;
`
